module.exports = __webpack_public_path__ + "za.svg?177080d3e910a20e5b030f916d77760a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/za.svg
// module id = 1702
// module chunks = 0